import store from "store";
import moment from "moment";

export default unit => moment().diff(store.game.startTime, unit);



// WEBPACK FOOTER //
// ./src/game/utils/elapsedGameTime.js